import { FORTA_WHITE } from '../../utils/colors';

import type { IconProps } from './types';

const SaveIcon = (props: IconProps) => {
  const { color = FORTA_WHITE, width = '24', height = '24', viewBox = '0 0 24 24' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 24C1.46667 24 1 23.8 0.6 23.4C0.2 23 0 22.5333 0 22V2C0 1.46667 0.2 1 0.6 0.6C1 0.2 1.46667 0 2 0H17.9333C18.2 0 18.4611 0.0555556 18.7167 0.166667C18.9722 0.277778 19.1889 0.422222 19.3667 0.6L23.4 4.63333C23.5778 4.81111 23.7222 5.02778 23.8333 5.28333C23.9444 5.53889 24 5.8 24 6.06667V22C24 22.5333 23.8 23 23.4 23.4C23 23.8 22.5333 24 22 24H2ZM22 6.13333L17.8667 2H2V22H22V6.13333ZM12 19.8333C12.9556 19.8333 13.7722 19.4944 14.45 18.8167C15.1278 18.1389 15.4667 17.3222 15.4667 16.3667C15.4667 15.4111 15.1278 14.5944 14.45 13.9167C13.7722 13.2389 12.9556 12.9 12 12.9C11.0444 12.9 10.2278 13.2389 9.55 13.9167C8.87222 14.5944 8.53333 15.4111 8.53333 16.3667C8.53333 17.3222 8.87222 18.1389 9.55 18.8167C10.2278 19.4944 11.0444 19.8333 12 19.8333ZM4.76667 8.53333H14.7C14.9889 8.53333 15.2278 8.43889 15.4167 8.25C15.6056 8.06111 15.7 7.82222 15.7 7.53333V4.76667C15.7 4.47778 15.6056 4.23889 15.4167 4.05C15.2278 3.86111 14.9889 3.76667 14.7 3.76667H4.76667C4.47778 3.76667 4.23889 3.86111 4.05 4.05C3.86111 4.23889 3.76667 4.47778 3.76667 4.76667V7.53333C3.76667 7.82222 3.86111 8.06111 4.05 8.25C4.23889 8.43889 4.47778 8.53333 4.76667 8.53333ZM2 6.13333V22V2V6.13333Z"
        fill={color}
      />
    </svg>
  );
};

export default SaveIcon;
